import type { ResourceCategory } from '@/mocks/resources';
import ResourceCard from './ResourceCard';

interface CategorySectionProps {
  category: ResourceCategory;
  index: number;
  savedIds: Set<string>;
  onToggle: (id: string) => void;
}

const CategorySection = ({ category, index, savedIds, onToggle }: CategorySectionProps) => {
  const no = String(index + 1).padStart(2, '0');

  return (
    <section id={category.id} aria-labelledby={`title-${category.id}`}>
      <div className="flex items-center gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-500 font-heading text-lg font-bold text-background-50">
          {no}
        </span>
        <div className="min-w-0">
          <h2 id={`title-${category.id}`} className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            {category.name}
            <span className="hidden rounded-full border border-accent-200 bg-accent-50 px-2 py-0.5 text-[11px] font-normal text-accent-800 sm:inline">
              {category.sub}
            </span>
          </h2>
          <p className="mt-0.5 text-xs text-foreground-600 md:text-sm">{category.intro}</p>
        </div>
        <span className="ml-auto hidden shrink-0 items-center gap-1 whitespace-nowrap rounded-full border border-background-200 bg-background-50 px-2.5 py-1 text-xs text-foreground-600 sm:flex">
          <i className="ri-database-2-line text-sm" aria-hidden="true" />
          收录 {category.list.length} 项
        </span>
      </div>

      <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
        {category.list.map((item) => (
          <ResourceCard
            key={item.id}
            item={item}
            saved={savedIds.has(item.id)}
            onToggle={onToggle}
          />
        ))}
      </div>
    </section>
  );
};

export default CategorySection;